module.exports = __webpack_public_path__ + "media/public/img/sponsors/ventatra-8dbc6cda119c833719b532f6d16ab25e.jpg";